module.exports = __webpack_public_path__ + "static/img/Paul-Vaughan.84dc238.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Paul-Vaughan.jpg
// module id = Fr8e
// module chunks = 0